import { useEffect, useState } from 'react';

/** Below this width Direct Sale switches to its phone layout (mock: 980px). */
const PHONE_QUERY = '(max-width: 980px)';

/**
 * Whether the phone layout applies. For choosing between two shells of the
 * same content — never for anything that would remount the canvas, which
 * stays in one place and is restyled with CSS instead.
 */
export function useIsPhone(): boolean {
  const [isPhone, setIsPhone] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(PHONE_QUERY).matches
  );

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia(PHONE_QUERY);
    const update = () => setIsPhone(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);

  return isPhone;
}
